import clsx from 'clsx'
import styles from '../VehicleAllocationColumn.module.scss'
import DotsIcon from '../../../assets/dots.svg'
import ChangeIcon from '../../../assets/change.svg'
import { AllocationChange, Allocation } from '@/types/vehicleAllocation'
import { useDraggable } from '@dnd-kit/core'
import { useVehicleAllocationStore } from '@/pages/VehicleAllocationController'

interface DraggableBonnetProps {
    allocation: Allocation
    allocationChange?: AllocationChange
    setIsManualEdit: (value: boolean) => void
    route: string
}

export const DraggableBonnet = ({ allocation, allocationChange, setIsManualEdit, route }: DraggableBonnetProps) => {
    const { routeEditing, activeId, runsWithErrors } = useVehicleAllocationStore()
    const isEditing = routeEditing === route
    const {
        attributes,
        listeners,
        setNodeRef: setDraggableNodeRef,
        over,
    } = useDraggable({
        id: allocation.run,
        data: { bonnet: allocationChange?.fleetNumber ?? allocation.bonnet },
        disabled: !isEditing,
    })

    if (activeId === allocation.run) return null

    const isValid = !runsWithErrors.includes(allocation.run)

    return (
        <div data-click-outside-exclude className={styles.bonnetContainer}>
            <div
                ref={setDraggableNodeRef}
                className={clsx(styles.bonnet, {
                    [styles.editing]: isEditing,
                    [styles.over]: over?.data?.current?.bonnet && over.id === allocation.run,
                })}
            >
                <button className={styles.editManualButton} disabled={!isEditing} onClick={() => setIsManualEdit(true)}>
                    {allocationChange ? (allocationChange.fleetNumber ?? '-') : (allocation.bonnet ?? '-')}
                    {(allocation.additionalData.history.length > 0 || (allocationChange && isValid)) && <ChangeIcon />}
                </button>

                {isEditing && (
                    <div className={styles.trigger} {...attributes} {...listeners}>
                        <DotsIcon />
                    </div>
                )}
            </div>
            {!isValid && <div className={styles.inputError}>Check the bonnet number</div>}
        </div>
    )
}
